<template>
  <section class="our-history body-container">
    <!-- subtitle -->
    <!-- <subtitle :title="'我们的历史'" titleEN="OUR HISTORY"></subtitle> -->

    <div class="steps-container">
      <el-carousel arrow="always" :autoplay="false" trigger="hover" ref="carousel">
        <el-carousel-item v-for="(item, index) in list" :key="index + 1">
          <ul class="history-steps">
            <li v-for="($item, $index) in item.step" :key="(index + 1) + '_' + $index" :active="-1" @click="onClick(index, $index)">
              <div><i></i></div>
              <p>{{$item}}</p>
            </li>
          </ul>
          <div class="describe">
            <h3>{{item.year}}</h3>
            <div v-if="language === '2'">{{item.desEN}}</div>
            <div v-else style="text-align: center">{{item.des}}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </section>
</template>

<script>
// import Subtitle from './Subtitle'

export default {
  name: 'OurHistory',
  // components: {
  //   Subtitle
  // },
  data () {
    return {
      active: 0,
      steps: ['1850', '1903', '1986', '2004', '2012', '2020'],
      list: [
        {
          year: '1850',
          des: '1850年，爱德华·迈克安德鲁斯和威廉·福布斯在土耳其创立了MacAndrews and Forbes公司，开始运输甘草并生产甘草提取物。',
          desEN: 'In 1850 Edward MacAndrews and William Forbes founded the MacAndrews and Forbes company in Turkey to begin transport licorice and produce licorice extract.',
          step: ['1850', '1903', '1986', '2004', '2012']
        },
        {
          year: '1903',
          des: '1903年工厂从土耳其迁到美国',
          desEN: 'In 1903 the factory moved from Turkey to the USA',
          step: ['1903', '1986', '2004', '2012', '2020']
        },
        {
          year: '1986',
          des: '1986年麦福并购法国的Extraits Végétaux et Dérivés公司，进一步拓展欧洲大陆的甘草生产及客户基础。',
          desEN: 'In1986 Mafco acquired the French company Extraits Végétaux et Dérivés company to further expand its licorice production capacity and its customer base in continental Europe.',
          step: ['1986', '2004', '2012', '2020', '1850']
        },
        {
          year: '2004',
          des: '2004年Mafco在张家港保税区建立一家现代工厂，致力于生产高质量的甘草衍生物。',
          desEN: 'In 2004 Mafco established a modern factory in Zhangjiagang Free Trade Zone, dedicated the production of high-quality licorice derivatives.',
          step: ['2004', '2012', '2020', '1850', '1903']
        },
        {
          year: '2012',
          des: '2012年麦福收购上海泛植制药有限公司（并于2016年更名为上海麦福生物制品有限公司），成为Mafco在中国另一家甘草衍生物制造公司。',
          desEN: '2012 Mafco acquired Shanghai Fanzhi Pharmaceutical Co., Ltd (and changed its names to Shanghai Mafco Biotech Co., Ltd in 2016) ，becoming Mafco\'s second licorice derivative manufacturing company in China.',
          step: ['2012', '2020', '1850', '1903', '1986']
        },
        {
          year: '2020',
          des: '2020年麦福被美国Whole Earth Brands公司收购，该公司在美国纳斯达克证券交易所上市。Whole Earth Brands是一家专注于为全球市场开发“better-for-you”产品的公司。',
          desEN: 'In 2020  Mafco is acquired by Whole Earth Brands, a USA public company on the USA NASDAQ stock exchange.  Whole Earth Brands is a company focused on the development of “better-for-you” products for the global marketplace.',
          step: ['2020', '1850', '1903', '2004']
        }
      ]
    }
  },
  computed: {
    language () {
      return this.$store.state.language || '1'
    }
  },
  methods: {
    onClick (i1, i2) {
      if (i1 + i2 <= this.list.length) {
        this.$refs.carousel.setActiveItem(i1 + i2)
      } else {
        this.$refs.carousel.setActiveItem(i1 + i2 - this.list.length)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/font.scss';

.our-history {
  margin: 60px auto;
  width: 100%;
  .iconfont {
    font-size: 40px !important;
    color: #999;
    background-color: #fff;
  }

  .steps-container {
    margin: 40px 0;
    position: relative;
  }

  .history-steps {
    text-align: center;
    color: #c0c4cc;
    list-style: none;
    display: flex;
    padding: 0 60px;
    li {
      flex: 1;
      div {
        height: 18px;
        position: relative;
      }
      p {
        margin-top: 10px;
      }
      &:hover {
        i {
          background-color: #87B026;
          transition: all 0.5s ease-in-out;
        }
      }
      i {
        border-width: 2px;
        border-style: solid;
        border-color: #c0c4cc;
        background-color: #fff;
        width: 14px;
        height: 14px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
        border-radius: 50%;
        cursor: pointer;

        &:hover {
          background-color: #004c2d;
          border-color: #004c2d;
        }
      }

      &:first-child {
        p {
          font-weight: bold;
          color: #004c2d;
        }
        i {
          border-color: #004c2d;
          background-color: #004c2d;
        }
      }
    }
    li:not(:last-child) div {
      &::after {
        content: '';
        display: block;
        position: absolute;
        z-index: 1;
        height: 2px;
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translateY(-50%);
        background-color: #c0c4cc;
      }
    }
  }

  .describe {
    width: 100%;
    margin: 0 auto;
    h3 {
      font-size: 30px;
      font-family: $Microsoft-YaHei;
      text-align: center;
    }

    div {
      text-align: left;
      font-size: 16px;
      font-family: $Microsoft-YaHei;
      padding-top: 30px;
    }
    div:last-of-type {
      margin-top: 0;
    }
  }
}

::v-deep .el-carousel__arrow {
  border: 2px solid #ccc;
  top: 20px;
  color: #ccc;
  background-color: #fff;

  &:hover {
    i {
      color: #fff;
    }
  }

    i {
      text-align: center;
      line-height: 32px;
      display: block;
      font-size: 22px;
    }
}
::v-deep .el-carousel__button {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #333;
}
::v-deep .el-carousel__indicator.is-active button {
  background-color: #333;
}
</style>
